import { LocalizedValueModel } from '../localized-value.model';

export class CurrencyPresenterModel {
  id?: string;
  decimalPlaces: number;
  displaySuffix: LocalizedValueModel;
  name: LocalizedValueModel;
}
